module.exports = __webpack_public_path__ + "static/media/4.06dee81.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/test/4.wav
// module id = FpfC
// module chunks = 0